import type { ISchedule, IUserFull } from "@gettactic/api";

/**
 * Extracts the primary user from a schedule.
 * Core API puts users inside slots; legacy API has user at top level.
 */
export function getScheduleUser(
  schedule: ISchedule | undefined | null
): IUserFull | undefined {
  if (!schedule) return undefined;
  return schedule.user || schedule.slots?.[0]?.user || schedule.organizer;
}
